(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const track = root.querySelector('[data-review-track]');
    const cards = [...track.children];
    const dialog = root.querySelector('dialog');
    const full = dialog.querySelector('[data-review-full]');
    const quote = dialog.querySelector('[data-review-quote]');
    const author = dialog.querySelector('[data-review-author]');
    const counter = dialog.querySelector('[data-review-counter]');
    const previous = root.querySelector('[data-review-scroll="-1"]');
    const next = root.querySelector('[data-review-scroll="1"]');
    let selected = 0;
    let opener;
    let oldOverflow;
    const show = (index) => {
      selected = (index + cards.length) % cards.length;
      const card = cards[selected];
      const photo = card.querySelector('img');
      full.src = card.querySelector('a').href;
      full.alt = photo.alt;
      full.width = Number(photo.dataset.fullWidth);
      full.height = Number(photo.dataset.fullHeight);
      quote.textContent = card.querySelector('blockquote').textContent;
      author.textContent = card.querySelector('[data-review-name]').textContent;
      counter.textContent = `${selected + 1} / ${cards.length}`;
    };
    root.querySelectorAll('[data-review-open]').forEach((link, index) => {
      link.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        opener = link;
        show(index);
        oldOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        dialog.querySelector('[data-review-close]').focus({ preventScroll: true });
      });
    });
    dialog.querySelector('[data-review-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = oldOverflow || '';
      opener?.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', (event) => {
      const r = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) dialog.close();
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        show(selected + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    dialog.querySelectorAll('[data-review-step]').forEach(button => button.addEventListener('click', () => show(selected + Number(button.dataset.reviewStep))));
    const update = () => {
      const limit = track.scrollWidth - track.clientWidth;
      previous.disabled = track.scrollLeft < 5;
      next.disabled = track.scrollLeft >= limit - 5;
      const rect = track.getBoundingClientRect();
      const visible = cards.map((card, index) => ({index, rect:card.getBoundingClientRect()})).filter(item => item.rect.left >= rect.left - 5 && item.rect.right <= rect.right + 5);
      if (visible.length) root.querySelector('[data-review-position]').textContent = `${visible[0].index + 1}${visible.length > 1 ? '–' + (visible.at(-1).index + 1) : ''} / ${cards.length}`;
    };
    root.querySelectorAll('[data-review-scroll]').forEach(button => button.addEventListener('click', () => {
      const step = cards[1].offsetLeft - cards[0].offsetLeft;
      const visible = Math.max(1, Math.floor((track.clientWidth + 20) / step));
      track.scrollBy({ left:Number(button.dataset.reviewScroll) * step * visible, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }));
    root.querySelector('[data-review-navigation]').hidden = false;
    track.addEventListener('scroll', update, { passive:true });
    const resize = new ResizeObserver(update);
    resize.observe(track);
    const unload = (event) => {
      if (event.target.contains(root)) {
        if (dialog.open) dialog.close();
        resize.disconnect();
        document.removeEventListener('shopify:section:unload', unload);
      }
    };
    document.addEventListener('shopify:section:unload', unload);
    update();
  };
  const mount = () => document.querySelectorAll('[data-customer-reviews]').forEach(init);
  mount();
  document.addEventListener('shopify:section:load', mount);
})();
